import { SvgProps } from '@svg/react/types'

export const monitorIconProps: SvgProps = {
  strokeColor: 'white',
  width: '24',
  height: '24',
  stroke: 2,
  size: 'm',
}

export const checkIconProps: SvgProps = {
  width: '16',
  height: '16',
  strokeColor: 'white',
  className: 'size-2.5',
}

export const chevronIconProps: SvgProps = {
  width: '20',
  height: '20',
  size: 'm',
  className: 'text-white',
}

export const actionIconProps: SvgProps = {
  size: 'm',
  height: '18',
  width: '18',
  strokeColor: 'white',
}
